import React from 'react';
import { useToast as useChakraToast, UseToastOptions } from '@chakra-ui/react';
import ToastBody from '../ToastBody';
import { ToastBodyProps } from '../ToastBody/ToastBody';

/**
 * A component to help with using Toasts
 */
export const useToast = (defaults?: UseToastOptions) => {
  const toastProps: UseToastOptions = {
    duration: 9000,
    position: 'bottom-right',
    isClosable: true,
    ...defaults,
  };

  const toast = useChakraToast({
    ...toastProps,
  });

  return (args?: ToastBodyProps) =>
    toast({
      // @ts-ignore Variant props are slightly different, not urgent
      render: ({ onClose }) => <ToastBody onClose={onClose} {...toastProps} {...args} />,
      ...args,
    });
};

export const useNeutralToast = (defaults?: UseToastOptions) => {
  const toast = useToast({
    variant: 'neutral',
    ...defaults,
  });

  return toast;
};

export const useInformativeToast = (defaults?: UseToastOptions) => {
  const toast = useToast({
    variant: 'informative',
    ...defaults,
  });

  return toast;
};

export const useNegativeToast = (defaults?: UseToastOptions) => {
  const toast = useToast({
    variant: 'negative',
    ...defaults,
  });

  return toast;
};
